<div
  class="theme"
  [ngClass]="
    {
      dark: 'mat-app-background cm-dark-theme',
      high: 'mat-app-background cm-high-contrast-theme',
      wentworth: 'mat-app-background cm-wentworth-theme'
    }[configuration.settings.theme]
  "
  >

  @if (showDebug$ | async; as showDebug) {
    <div class="debug-debris">
      @if (associations$ | async; as associations) {
        <div class="associations">
          @if (currentUser$ | async; as currentUser) {
            <cm-associations-debug-viewer [associations]="associations" [resident]="currentUser"></cm-associations-debug-viewer>
          }
        </div>
      }
      <div class="indicators">
        <cm-camera-present-indicator></cm-camera-present-indicator>
        <cm-conferencing-subscription-indicator></cm-conferencing-subscription-indicator>
        <cm-network-indicator></cm-network-indicator>
        <cm-av-input-indicator></cm-av-input-indicator>
        <cm-memory-indicator></cm-memory-indicator>
        <cm-cpu-indicator></cm-cpu-indicator>
      </div>
    </div>
  }
  <router-outlet></router-outlet>
</div>
